/*
 * Copyright (c) Worldline 2023.
 */

import {Component} from '@angular/core';
import {Idle} from "@ng-idle/core";
import {RootScopeService} from "./services/rootscope.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {IdlePopupComponent} from "./components/idle-popup/idle-popup.component";
import {TimeoutPopupComponent} from "./components/timeout-popup/timeout-popup.component";
import {RedirectionService} from "./services/redirection.service";
import {ActivationEnd, Router} from "@angular/router";
import {filter} from "rxjs";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  title = 'sbx-front-new';

  constructor(private idle: Idle, private rootScope: RootScopeService, private modalService: NgbModal, private redirectionService: RedirectionService, private router: Router) {

    idle.onIdleStart.subscribe(() => {
      console.debug('Idle detected ! - Activated : ' + rootScope.get().idleActivated);
      if (rootScope.get().idleActivated) {
        this.openIdleDialog();
      } else {
        idle.stop()
        idle.watch();
      }
    })

    idle.onTimeout.subscribe(() => {
      console.warn('Timeout detected ! - Activated : ' + this.rootScope.get().idleActivated);
      if (this.rootScope.get().idleActivated) {
        this.openTimeOutDialog();
      }
    })

    this.router.events.pipe(
        filter(e => e instanceof ActivationEnd)
    ).subscribe(event => {
      idle.interrupt();
    })

    rootScope.get().enableIdling = function (enable) {
      rootScope.get().idleActivated = enable;
    };

    idle.watch();
  }

  ngOnInit() {
  }

  private openIdleDialog() {
    const that = this;

    //Close all dialogs
    this.modalService.dismissAll();

    //Open idle dialog
    this.modalService.open(IdlePopupComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    }).result.then(result => {
      that.idle.stop();
      switch (result) {
        case 'VALID':
          console.debug('Session still valid, can continue');
          this.idle.watch();
          break;
        case 'UNVALID':
          console.warn('Session is not valid');
          that.openTimeOutDialog();
          break;
        default:
          console.warn('Unknown error');
          break;
      }
    }, (reason => console.log(reason)));
  }

  private openTimeOutDialog() {

    //Close all dialogs
    this.modalService.dismissAll();

    //Open timeout dialog
    this.modalService.open(TimeoutPopupComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    }).result.then(url => {
      this.redirectionService.exit(url);
    })
  }


}
